import { SchedulesPage } from "@/components/Schedules/SchedulesPage";

export function Schedules() {
  return <SchedulesPage />;
}
